import axios from 'axios';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Box, Center, Divider, Image, Text, useToast } from '@chakra-ui/react';

import TopLinks from '../../../components/TopLinks';
import ReactHelmet from '../../../components/ReactHelmet';
import { getServices } from '../../About/actions/actions';

import left from '../../../assets/left.png';
import right from '../../../assets/right.png';

const PageFive = () => {
  const { data, isLoading, isError, error } = useQuery('services', getServices);

  const toast = useToast();

  const [pageData, setPageData] = useState(null);
  const [websiteSettings, setWebsiteSettings] = useState([]);

  const handleServices = () => {
    if (data) {
      setPageData(data.data.data);
    }
    if (isError) {
      toast({
        title: 'Error',
        status: 'Error',
        duration: 10000,
        description: error,
        position: 'top-right',
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handleServices();
    }, 0);
  });

  useEffect(() => {
    const getWebsiteData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/website-settings`
        );

        setWebsiteSettings(response?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };

    getWebsiteData();
  }, []);

  return (
    <>
      <ReactHelmet title={'Our Services | Bank Enterprise'} />

      <Box
        h={'auto'}
        display={'flex'}
        flexDir={'column'}
        justifyContent={'space-between'}
        boxShadow={'3px 3px 200px #000 inset'}
        padding={['10px 0', '10px 0', '2rem 0', '2rem 0', '2rem 0']}
        w={[
          '100%',
          '100%',
          'calc(100% - 200px)',
          'calc(100% - 304px)',
          'calc(100% - 304px)',
        ]}
        background={
          websiteSettings?.background_images?.other_page_bg_type === 'color'
            ? websiteSettings?.background_images?.other_page_bg_value
            : `url('${websiteSettings?.background_images?.other_page_bg_value}')`
        }
        backgroundSize={'cover'}
        backgroundRepeat={'no-repeat'}
      >
        <Box
          flexDir={'row'}
          display={'flex'}
          gap={[4, 4, 5, 5, 5]}
          px={[5, 5, 5, 10, 10]}
          mt={[0, 0, 10, 10, 10]}
          justifyContent={'flex-end'}
        >
          <TopLinks />
        </Box>
        <Box
          px={10}
          w={'100%'}
          flexDir={'row'}
          display={'flex'}
          justifyContent={'center'}
        >
          <Box
            mb={10}
            w={'100%'}
            gap={'1rem'}
            display={'flex'}
            flexDir={'column'}
            px={[0, 0, 10, 10, 10]}
          >
            <Box
              w={'100%'}
              gap={'1rem'}
              flexDir={'row'}
              display={'flex'}
              flexWrap={'wrap'}
              alignItems={'center'}
              alignContent={'center'}
              justifyContent={'center'}
              marginTop={['3rem', '3rem', 0, 0, 0]}
            >
              <Text
                color={'white'}
                fontFamily={'Poppins'}
                fontSize={[18, 18, 18, 20, 25]}
              >
                Over the
              </Text>

              <Text
                color={'#E76D0C'}
                fontFamily={'Poppins'}
                fontSize={[18, 18, 18, 20, 25]}
              >
                Counter Services
              </Text>

              <Divider
                ml={4}
                w={'45%'}
                borderWidth={3}
                borderRadius={5}
                borderColor={'#E76D0C'}
                orientation={'horizontal'}
              />
            </Box>
            <Center>
              <Box
                my={10}
                gap={15}
                w={'100%'}
                flexWrap={'wrap'}
                display={'inline-flex'}
                justifyContent={'center'}
              >
                {pageData &&
                  pageData.length > 0 &&
                  pageData.map((dd) => {
                    return (
                      <Image
                        src={dd?.url}
                        height={'auto'}
                        objectFit={'contain'}
                        w={[120, 120, 159, 200, 200]}
                      />
                    );
                  })}
              </Box>
            </Center>
          </Box>
        </Box>
        <Box
          my={10}
          px={10}
          display={'flex'}
          letterSpacing={1}
          gap={[0, 2, 3, 3, 3]}
          alignItems={'center'}
          justifyContent={'flex-end'}
          flexDir={['column', 'column', 'row', 'row', 'row']}
        >
          <Text
            color={'#E76D0C'}
            fontFamily={'Poppins'}
            fontSize={[20, 20, 20, 30, 30]}
          >
            OUR SERVICES
          </Text>

          <Box display={'flex'} letterSpacing={1} gap={[2, 2, 3, 3, 3]}>
            <Link to={'/offers'}>
              <Image
                src={left}
                mt={[10, 10, 0, 0, 0]}
                w={['30px', '30px', '30px', '40px', '40px']}
              />
            </Link>
            <Link to={'/milestones'}>
              <Image
                src={right}
                mt={[10, 10, 0, 0, 0]}
                w={['30px', '30px', '30px', '40px', '40px']}
              />
            </Link>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PageFive;
